import React from 'react';
import ActionButton from '../buttons/action-button';
import DeleteButton from '../buttons/delete-button';

class NamedIntegrations extends React.Component {

  render() {
    return <ul className="list-group">
      {this.props.integrations.map(integration =>
        <li key={integration.id} className="list-group-item">
          <div className="row align-items-center">
            <div className="col">
              {integration.name}
            </div>
            <div className="col-auto">
              <ActionButton className="btn-sm btn-secondary px-4"
                            action={() => this.props.editAction(integration.id)}
                            errorHandler={this.props.errorHandler}>
                Edit
              </ActionButton>
            </div>
            <div className="col-auto">
              <DeleteButton action={() => this.props.deleteAction(integration.id)}
                            errorHandler={this.props.errorHandler}/>
            </div>
          </div>
        </li>
      )}
      <li className="list-group-item">
        <div className="row">
          <div className="col">
          </div>
          <div className="col-auto">
            <button type="button"
                    className="btn btn-sm btn-success"
                    onClick={() => this.props.createAction()}>
              {(this.props.integrations || []).length > 0 ?
                <span className="material-icons align-middle">add</span> :
                <span>Create integration</span>
              }
            </button>
          </div>
        </div>
      </li>
    </ul>;
  }

}

export default NamedIntegrations;
